var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4"},_vm._l((_vm.businesses),function(business,i){return _c('div',{key:business.id + '-' + i},[_c('BusinessListItem',{staticClass:"pb-8",attrs:{"business":business,"colored":i % 2 === 0}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }